import { StripePriceAnonymous } from "@switcherstudio/switcher-api-client";
import { useState, useEffect } from "react";
import rollbar from "helpers/rollbar";
import { useSwitcherClient } from "./useSwitcherClient";

export function useGetStripePrice(
    priceId: string | undefined,
    warningMessage?: string
): { plan: StripePriceAnonymous; loading: boolean } {
    const [plan, setPlan] = useState<StripePriceAnonymous>();

    const { dispatchApiRequest } = useSwitcherClient(
        (client) => client.stripePrices_GetPriceInfo,
        {
            requestImmediately: false
        }
    );

    useEffect(() => {
        const run = async () => {
            if (priceId) {
                try {
                    setPlan(await dispatchApiRequest([priceId]));
                } catch (e) {
                    rollbar.warning(
                        "Error getting stripe price",
                        e,
                        warningMessage
                    );
                }
            }
        };

        run();
    }, [dispatchApiRequest, priceId, warningMessage]);

    return { plan, loading: !plan };
}
